/**
 * Lab sportsbook-detail: Invalid Bets checkbox only for WON / LOST
 * (not INVALID_BET / VOID / …).
 */
export function canSelectBetForInvalidAfterResult(bet: { status?: string }): boolean {
  const s = String(bet.status ?? '')
    .trim()
    .toUpperCase()
  return s === 'WON' || s === 'LOST' || s === 'WIN' || s === 'LOSE'
}
